import { Component,ViewChild, Input, OnChanges , Output, EventEmitter} from '@angular/core';

import { ActivatedRoute, Params } from '@angular/router';
import { GenService } from '../../../shared/gen-ser.service';
import { DataService } from '../../../shared/dataservice.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

import {trigger, transition, style, animate, state} from '@angular/animations';
import { InprocessQualityIssues, IQIToken, IQIDayToken, DailyTokenItem, DailyToken, itsQIssueSummary, subProduct, itsQIssue, GenResponse} from 'app/shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ErrorPopupComponent } from 'app/common/error-popup/error-popup.component';
import * as XLSX from 'xlsx';


@Component({
  selector: 'inpr-qual-day-view',
  templateUrl: './inpr-qual-day-view.component.html',
  styleUrls: ['./inpr-qual-day-view.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
        ':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', 'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({transform: 'translateX(0)', 'opacity': 1}),
          animate('500ms', style({transform: 'translateX(100%)', 'opacity': 0})
          
          )]
      )]
    )
  ]
})


export class InprQualDayViewComponent implements OnChanges {

  qualIssueSummary:Array<itsQIssueSummary> = [];


  editToken: string = '';
  editHeader: string = '';
  editText: string = '';
  editType: string = '';
  editParam1: any;
  editParam2: any;
  moduleKeyName: string = "daily_prod_high";
  currMonthDtObj: Date = new Date();
  shortageFlag:boolean = false;
  severityFlag:boolean = false;
  isNewRecord:boolean = false;
  prevValue:string = 'no';

  generateExcelFromDate:any;
  generateExcelToDate:any;

  shortageFlag_modified:boolean = false;
  severityFlag_modified:boolean = false;
  isNewRecord_modified:boolean = false;
  prevValue_modified:string = 'no';

  mId:string = "773881e1-3f3a-49be-865a-1a2f0312be8d";
  editRow:IQIToken;
  //editRow1:DPHToken1;
  
  shortagechangedvariable:any ;
  severityvar:any;

  inProcessQualObj:InprocessQualityIssues;
  IQIDayTokenObj:IQIDayToken;

  isLoading: boolean = false;
  isLoaded: boolean = false;
  isFailed: boolean = false;
  failMessage: string = '';

  selView: number = 1;
  areChangesMade: boolean = false;

  // planObj: Plan;
  // planQty:string = '';
  btnName: string = '';


  daywiseItemList: Array<DailyToken>;
  subProductList:Array<subProduct>= [];

  @Input() productLineID:string;
  @ViewChild('childModal') public childModal: ModalDirective;
  @ViewChild('importModal') public importModal:ModalDirective;
  @ViewChild('exportModal') public exportModal:ModalDirective;  
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  // public _severityStatus = SeverityStatus;
  //public _severityStatus_modified = SeverityStatus;
   


  isImportModalShown:boolean = false;
  isExportSavingMode:boolean = false;
  exportSavingMessage:string = "";
  isImportDataLoading:boolean = false;
  editDate: Date;
  changesFlag: any;
  // dDPHDayTokenObj: IQIDayToken;
  
  

  constructor(public _dataService: DataService,
    private _activatedRoute: ActivatedRoute, private _notify: NotificationsService) { }

  ngOnChanges() {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['month']) {
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
      // this.loadSubProducts()
    });
  }
  //  loadSubProducts(){
  //   this.subProductList = [];
  //   for(var i=0;i<this._dataService.subProduct.length;i++){
  //     if(this._dataService.subProduct[i].productId == this.productLineID){
  //       this.subProductList.push(this._dataService.subProduct[i])
  //     }
  //   }
  //   return this.subProductList;
  // }

  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  
  shortageChanged(val) {
    //console.log("are we really here ? ",val, this.isNewRecord,this.prevValue);
     this.shortagechangedvariable = val;
    if(this.isNewRecord)
    {
      if (val == 'yes')
       {
        this.shortageFlag = true;
      }
      else
      {
        this.editRow.severityValue = null;
        this.editRow.shortageNotes = null;
        this.severityFlag = false;
        this.shortageFlag = false;
      }
    }
    else
    {
      if(val == 'no'){
        this.editRow.severityValue = null;
        this.editRow.shortageNotes = null;
        this.severityFlag = false;
        this.shortageFlag = false;
      }
      else if(val == 'yes' && this.prevValue == 'no'){
        this.shortageFlag = true;
      }
      else{
        this.severityFlag = true;
      }
    }
    //take variable name instead of return
    // return this.shortagechangedvariable;
    console.log("shortage var",this.shortagechangedvariable);
  }

  severityClicked(editRow,option){
    this.severityFlag = true;
    this.editRow.severityValue = option;
 

}


  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadinprocessqualityissues(this.currMonthDtObj, this.productLineID).subscribe((_cstInspPlan:InprocessQualityIssues) => {
      if (_cstInspPlan != null) {
        this.inProcessQualObj = _cstInspPlan;
        this.loadDateData();

        let _tmpDailyTokenList: Array<DailyToken> = [];
        for (var i = 0; i < this.inProcessQualObj.dayTokens.length; i++) {
          let _tmpDate:Date = this.inProcessQualObj.dayTokens[i].selDate;
          let _tmpDailyTokens:Array<DailyTokenItem> = [];
          
          let _indexer:number = 0;
          this.inProcessQualObj.dayTokens[i].dateTokens.forEach((_tmpObj:IQIToken) => {
            _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.productName,0), this.getIdObj(_tmpDate,_indexer),''));
            _indexer++;
          });
          _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
        }

        this.daywiseItemList = _tmpDailyTokenList;
        this.isLoaded = true;
        this.isLoading = false;
        this.isFailed = false;
      }
      else {
        this.daywiseItemList = null;
        this.isLoaded = false;
        this.isLoading = false;
        this.isFailed = true;
        this.failMessage = "Failed to get data from database, try again";
      }
    });
  }

  showImportModel(){
    this.isExportSavingMode = false;
    this.isImportModalShown = true;
    this.exportSavingMessage = "";
    this.importModal.show();
    this.isImportDataLoading = true;
    this.qualIssueSummary = [];
    setTimeout(() => {
      this.getImportData();  
    }, 200);    
   
  }

  getImportData(){
    this.isImportDataLoading = true;
    this._dataService.loadInprocessQualityImportData().subscribe((_issues:Array<itsQIssue>) => {
      // console.log("Issues :: " ,_issues)
        this.isImportDataLoading = false;
        if(_issues){
          let _tmpIssueSummary:Array<itsQIssueSummary> = [];
          // console.log("console for issues",_issues)
          _issues.forEach((_tmpQIssue:itsQIssue) => {
            //if(_tmpQIssue.tStamp > this.maxImportTstamp){
            //  this.maxImportTstamp = _tmpQIssue.tStamp;
            //}
            let _index:number = _tmpIssueSummary.findIndex((_tmpObj:itsQIssueSummary) =>{
              return _tmpObj.issueId == _tmpQIssue.issueId;
            });

            if(_index >= 0){
              _tmpIssueSummary[_index].quantity++;
            }
            else{
              let issueCapTime:Date = new Date(_tmpQIssue.issueCaptureTime);
              //this.extractProductCategory(_tmpQIssue.psId);
              var gembaProdLineId:string = this.getGembaLineId(_tmpQIssue.lineId);
              
              if(this.productLineID == gembaProdLineId){
                _tmpIssueSummary.push(new itsQIssueSummary(
                  gembaProdLineId,this.getGembaProductId(_tmpQIssue.productId),
                  _tmpQIssue.issueId, 
                  this.getGembaStationId(_tmpQIssue.stationId),
                   1 , issueCapTime, _tmpQIssue.issueDescription, _tmpQIssue.docid));
              }
              
            }
          });
          _tmpIssueSummary.sort((_a:itsQIssueSummary, _b:itsQIssueSummary) => { 
            if(_a.issueCaptureDate <  _b.issueCaptureDate) return 1;
            if(_a.issueCaptureDate >  _b.issueCaptureDate) return -1;
            return 0;
          });
          this.qualIssueSummary = _tmpIssueSummary;
          // console.log("issue summary",_tmpIssueSummary)
        }
    });
  //console.log("Prod ID info here :",this.getGembaProductId)
  // this.discardImportedData();
  }

  // discardImportedData(){
  //   // if(confirm("Are you sure ? You will not be able to see these records again.") == true)
  //     var _records:any = [];
  //     this.qualIssueSummary.forEach((_qualIssue:itsQIssueSummary) => {
  //       if(_qualIssue.isSelected == true){
  //         _records.push(_qualIssue)
  //       }
  //     });
  //     if(_records.length == 0){
  //       // alert('No records selected to discard.');
  //       return;
  //     }
  //     if(_records.length > 50){
  //       alert('You cannot discard more than 50 records at a time, please uncheck some records.');
  //       return;
  //     }
  //     this._dataService.discardExportInprocessRecords(_records)
  //     .subscribe((_retVal:boolean) => {
  //      this.showImportModel();
  //     });
    
    
  // }
  discardData2(){
    if(confirm("Are you sure ? You will not be able to see these records again.") == true){
      var _records:any = [];
      this.qualIssueSummary.forEach((_qualIssue:itsQIssueSummary) => {
        if(_qualIssue.isSelected == true){
          _records.push(_qualIssue)
        }
      });
      if(_records.length == 0){
        alert('No records selected to discard.');
        return;
      }
      if(_records.length > 50){
        alert('You cannot discard more than 50 records at a time, please uncheck some records.');
        return;
      }
      this._dataService.discardExportInprocessRecords(_records)
      .subscribe((_retVal:boolean) => {
       this.showImportModel();
      });
    }
    
  }

    getGembaLineId(_itsLineId:string){
    if(this._dataService.itsToGembaLineIdMapping[_itsLineId]){
      return this._dataService.itsToGembaLineIdMapping[_itsLineId];
    }
    return "";
  }
  getGembaStationId(_itsStationId:string){
    if(this._dataService.itsToGembaStationIds[_itsStationId]){
      return this._dataService.itsToGembaStationIds[_itsStationId];
    }
    return "";
  }

  getGembaProductId(_itsProductId:string){
    if(this._dataService.itsToGembaProductIdMapping[_itsProductId]){
      return this._dataService.itsToGembaProductIdMapping[_itsProductId];
    }
    return "";
  }

    getGembaPSId(_itsPSName:string){
    for(var i = 0; i < this._dataService.subProduct.length; i++){
      if(this._dataService.subProduct[i].subProductName == _itsPSName){
        return this._dataService.subProduct[i].subProductId;
      }
    }
    return "";
  }

  getGembaManfStat(_itsManfSt:string){
    if(_itsManfSt == "0"){
      return "Pending";
    }
    return "Completed";
  }

  getGembaSeverity(_itsSev:string){
    let x = ["Disturbance", "Production_Loss","Not_A_Concern"];
// Initialize it
    
    return x;
  }

  getImportSelectedCount(){
    let _retVal:number = 0;
    this.qualIssueSummary.forEach((_qualIssue:itsQIssueSummary) => {
      if(_qualIssue.isSelected == true){
        _retVal++;
      }
    });

    return _retVal;
  }
    importSelected(){
      if(this.getImportSelectedCount() > 0){
        if(confirm("Are you sure to save? click OK to continue.") == true){
          this.exportSavingMessage = "Save operation started...";
           this.exportDataToDB();
        }
      }
      else{
        alert("No records selected to import.")
      }
    }

    exportDataToDB(){
      let lineIdArray:Array<string> = [];
      this.qualIssueSummary.forEach((_qualIssue:itsQIssueSummary) => {
        if(_qualIssue.isSelected)
        {
          var _lineId:string = _qualIssue.lineId;
          if(lineIdArray.indexOf(_lineId) < 0)
          {
            lineIdArray.push(_lineId);
          }
          console.log("lineidarray",lineIdArray)
        }
      });
  
      this.exportToLine(0, lineIdArray);
  
    }

    exportToLine(_exportLineIndex:number, _lineIdArray:Array<string>){
      if(_exportLineIndex < _lineIdArray.length){
        //read the line document for the current month 
        this.exportSavingMessage = "Fetching data from server<br/>" + this.exportSavingMessage;
  
        let _currMonthObj: Date = new Date();
        this._dataService.loadinprocessqualityissues(_currMonthObj, _lineIdArray[_exportLineIndex])
          .subscribe((_inprocQualIssue: InprocessQualityIssues) => {
  
            if (_inprocQualIssue) {
              let _exportIssueForLine: Array<itsQIssueSummary> = this.getExportIssuesForThisLine(_lineIdArray[_exportLineIndex]);
  
              _exportIssueForLine.forEach((_tmpIssueSumm: itsQIssueSummary) => {
                _inprocQualIssue.addDateToken(_currMonthObj,
                  new IQIToken(GenService.getGUID(), _tmpIssueSumm.productId, null, _tmpIssueSumm.issueDescription,
                    _tmpIssueSumm.quantity + '', null, null, null, _tmpIssueSumm.stationId, null, null, null, null, null, null,
                    null, null, null, null, null, null, _tmpIssueSumm.issueCaptureDate.getTime(), null,null));
  
              });
  
              this._dataService.saveInprocessQualityIssues(_inprocQualIssue, _lineIdArray[_exportLineIndex], false)
                .subscribe((resp: GenResponse) => {
                  if (resp.status == "FAIL") {
                    this.exportSavingMessage = "FAILED TO SAVE <br/>" + this.exportSavingMessage;
                  }
                  else {
                    //this._notify.success('Success', resp.details,this._dataService.successOptions);
                    _exportLineIndex++;
                    this.exportToLine(_exportLineIndex, _lineIdArray);
                  }
                });
            }
            else {
              _exportLineIndex++;
              this.exportToLine(_exportLineIndex, _lineIdArray);
              
            }
  
          });
  
        //add the export records and save the document
      }
      else{
        //operation complete.
        this.exportSavingMessage = "OPERATION COMPLETED<br/>" + this.exportSavingMessage;
  
        var _records:any = [];
        this.qualIssueSummary.forEach((_qualIssue:itsQIssueSummary) => {
          if(_qualIssue.isSelected == true){
            _records.push(_qualIssue)
          }
        });
        if(_records.length > 0){
          this._dataService.discardExportInprocessRecords(_records)
          .subscribe((_retVal:boolean) => {
            setTimeout(() => {
              this.isImportModalShown = false;
              this.importModal.hide();
            }, 100);
            this.loadMonthData();
          });  
        }
        else{
          setTimeout(() => {
            this.isImportModalShown = false;
            this.importModal.hide();
          }, 100);
          this.loadMonthData();
        }
        
  
        
      }
  
    }
  
    getExportIssuesForThisLine(_lineId:string):Array<itsQIssueSummary>{
      return this.qualIssueSummary.filter((_tmpObj:itsQIssueSummary) => {
        return (_tmpObj.lineId == _lineId) && (_tmpObj.isSelected == true);
      });
    }
 
    private getDisplayTokenName(_prodId:string,_quantity:number){
    return this._dataService.getProductName(_prodId) + ' ('+_quantity+')';
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.editRow = _param1.cloneSelf();
      this.editType = _editToken;
      this.severityFlag = true;
        this.editHeader = "Edit Inprocess Quality Issues (" + this.formatHeaderDate(this.IQIDayTokenObj.selDate) +")";
      break;
      case "newrow":
      this.editRow = new IQIToken(GenService.getGUID(),null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,(new Date()).getTime(),null,null)
      this.editType = _editToken;
      this.editHeader = "Add Inprocess Quality Issues (" + this.formatHeaderDate(this.IQIDayTokenObj.selDate) +")";
      break;
      case "date":
        this.editDate = this.inProcessQualObj.monthDate;
        this.editType = 'date';
        this.editHeader = "Edit Date";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  dataEdited(){
    switch(this.editToken){
      case "rowedit":
      this.severityFlag = true;
        this.editParam1.issueRelated = this.editRow.issueRelated;       
        this.editParam1.productName = this.editRow.productName;
        this.editParam1.productType = this._dataService.getProductTypeBasedOnProductId(this.editRow.productName);
        this.editParam1.supplierName = this.editRow.supplierName;
        this.editParam1.quantity = this.editRow.quantity;
        this.editParam1.rootCause = this.editRow.rootCause;
        if(this.editRow.targetDate){
          
        this.editParam1.targetDateNum = this.editRow.targetDate.getTime();
        }
        this.editParam1.actionDecided = this.editRow.actionDecided;
        this.editParam1.preventiveAction = this.editRow.preventiveAction;
        this.editParam1.ncrCapturing = this.editRow.ncrCapturing;
        this.editParam1.issueCapturing = this.editRow.issueCapturing;
        this.editParam1.defectCategory = this.editRow.defectCategory;  
        this.editParam1.respPrsn = this.editRow.respPrsn;     
        this.editParam1.defectSubCategory1 = this.editRow.defectSubCategory1;
        this.editParam1.defectSubCategory2 = this.editRow.defectSubCategory2;
        this.editParam1.defectSubCategory3 = this.editRow.defectSubCategory3;
        this.editParam1.dispositionDecision = this.editRow.dispositionDecision;
        this.editParam1.status = this.editRow.status;
        this.editParam1.rowId = this.editRow.rowId;
        this.editParam1.shortageNotes = this.editRow.shortageNotes;
        this.editParam1.creationDate = this.editRow.creationDate;
        this.editParam1.severityValue = this.editRow.severityValue;
      break;
      case "newrow":
      this.inProcessQualObj.addDateToken(new Date(this.currMonthDtObj),
      new IQIToken(this.editRow.rowId,this.editRow.productName,this._dataService.getProductTypeBasedOnProductId(this.editRow.productName),this.editRow.productDesc,this.editRow.quantity,this.editRow.issueRelated,
                   this.editRow.supplierName,this.editRow.ncrCapturing,this.editRow.issueCapturing,this.editRow.defectCategory,
                   this.editRow.defectSubCategory1,this.editRow.defectSubCategory2,this.editRow.defectSubCategory3,this.editRow.rootCause,
                   this.editRow.dispositionDecision,this.editRow.actionDecided,this.editRow.preventiveAction,this.editRow.respPrsn,
                   this.editRow.targetDateNum,this.editRow.status,this.editRow.shortageNotes,this.editRow.creationDate,this.editRow.severityValue,null));
      console.log("created date",this.editRow.creationDate)
                   break;
      case "date":
        this.inProcessQualObj.monthDate = this.editDate;
        this.currMonthDtObj = this.editDate;
        // this.saveData();
        break
    }
    //this.changesFlag.emit(true);
    this.hideChildModal();
  }

  // savePlan(){
  //   this._dataService.saveInprocessQualityIssues(this.productLineID)
  //   .subscribe((resp: GenResponse) => {
  //     if (resp.status == "FAIL") {
  //       if(resp.errorCode == DataService.staleDataCode){
  //         this.errorPopup.showErrorPopup("Stale Data",resp.details);
  //       }else{
  //         this._notify.error('Failure', resp.details, this._dataService.failureOptions);
  //       }
  //     }
  //     else {
  //       this._notify.success('Success', resp.details, this._dataService.successOptions);
  //       this.loadMonthData();
  //     }
    
  //   });
  // }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  hideImportModal(){
    this.isImportModalShown = false;
     this.importModal.hide();
  }
  public addNewProdRow(_newRowToken:string,_dayIndex:number){
    switch(_newRowToken){
      case "newrow":
        this.showChildModal(_newRowToken,null,null);
        this.editType = "newrow";
        this.severityFlag = false;
      break;
    }
  }
  
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getIssueRelatedTo(_id:string):string{
    if(_id)
      return this._dataService.getIssueRelated(_id)
    return ''
  }
  getDefectCategory(_id:string):string{
    if(_id)
      return this._dataService.getDefectCategory(_id)
    return ''
  }
  getIssueCapturing(_id:string):string{
    if(_id)
      return this._dataService.getIssueCapturing(_id)
    return ''
  }
  getDefectSubCategory1(_id:string):string{
    if(_id)
      return this._dataService.getDefectSubCategory1(_id)
    return ''
  }
  getDefectSubCategory2(_id:string):string{
    if(_id)
      return this._dataService.getDefectSubCategory2(_id)
    return ''
  }
  getDefectSubCategory3(_id:string):string{
    if(_id)
      return this._dataService.getDefectSubCategory3(_id)
    return ''
  }
  getDispositionDecision(_id:string):string{
    if(_id)
      return this._dataService.getDepositionDecision(_id)
    return ''
  }
  getStatus(_id:string):string{
    if(_id)
      return this._dataService.getStatus(_id)
    return ''
  }
  getNCRCapturing(_id:string):string{
    if(_id)
      return this._dataService.getNCRCapturing(_id)
    return ''
  }
  getSupplierName(_id:string):string{
    if(_id)
      return this._dataService.getSupplierName(_id)
    return ''
  }
  getData(option){
    if(option) return option
    return ''
 }
 getResponsiblePrsn(_prsn:string):string{
   if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
   return ''
 }
  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    } else {
      return null;
    }
  }
  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }

  public hideChildModal(): void {
    this.childModal.hide();
    this.importModal.hide();
  }

  public discardSaveData(): void {
    this.childModal.hide();
     //this.importModal.hide();

  }

  discardData(): void {
    this.loadMonthData();
  }

  validateData(): boolean {
    return true;
  }

  saveData(_sendMail:boolean):void{
    if(this.validateData()==true){
      console.log("save obj",this.inProcessQualObj,"prod line",this.productLineID)
      this._dataService.saveInprocessQualityIssues(this.inProcessQualObj,this.productLineID,_sendMail)
      .subscribe((resp:GenResponse) => {
        if(resp.status == DataService.statusFail){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
        }

      });
    }
  }

  
  removeRecord(_tokenIndex:number){
    this.areChangesMade = true;
    this.IQIDayTokenObj.removeToken(_tokenIndex);
}

showExportModel(){
  this.editHeader = "Export To Excel";
  this.generateExcelFromDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
  this.generateExcelToDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
  this.exportModal.show();

}

hideexportModal()
{
  this.exportModal.hide()
}

exportToExcel(){
  var startDate = new Date(this.generateExcelFromDate);
  var endDate  = new Date(this.generateExcelToDate);
  if(this.validateStartEndDate(startDate,endDate)){
      this._dataService.downloadFile(startDate,endDate,"Inprocess",this.productLineID);
      this.hideexportModal();
  }
  // let data = [ { product_line_id: '664aab80-cb21-42b0-fd3e-48dbd4809f09',
  //   seldate: '20210304',
  //   productName: '',
  //   productDesc:
  //    'Breaker not able to open during hv test with manual tripping handle',
  //   quantity: '1',
  //   issueRelated: null,
  //   supplierName: null,
  //   ncrCapturing: null,
  //   issueCapturing: 'pole assembly station',
  //   defectCategory: null,
  //   defectSubCategory1: null,
  //   defectSubCategory2: null,
  //   defectSubCategory3: null,
  //   rootCause: null,
  //   dispositionDecision: null,
  //   actionDecided: null,
  //   preventiveAction: null,
  //   respPrsn: null,
  //   targetDateNum: null,
  //   status: null },
  // { product_line_id: 'breaker',
  //   seldate: '20210304',
  //   productName: '',
  //   productDesc: 'thermostat faulty (OTHER)',
  //   quantity: '1',
  //   issueRelated: null,
  //   supplierName: null,
  //   ncrCapturing: null,
  //   issueCapturing: 'ma assembly station',
  //   defectCategory: null,
  //   defectSubCategory1: null,
  //   defectSubCategory2: null,
  //   defectSubCategory3: null,
  //   rootCause: null,
  //   dispositionDecision: null,
  //   actionDecided: null,
  //   preventiveAction: null,
  //   respPrsn: null,
  //   targetDateNum: null,
  //   status: null },
  // { product_line_id: 'breaker',
  //   seldate: '20210304',
  //   productName: '',
  //   productDesc: 'TNC switch k53 wire lug openTb 304 112 113 damaged (OTHER)',
  //   quantity: '1',
  //   issueRelated: null,
  //   supplierName: null,
  //   ncrCapturing: null,
  //   issueCapturing: 'ma assembly station',
  //   defectCategory: null,
  //   defectSubCategory1: null,
  //   defectSubCategory2: null,
  //   defectSubCategory3: null,
  //   rootCause: null,
  //   dispositionDecision: null,
  //   actionDecided: null,
  //   preventiveAction: null,
  //   respPrsn: null,
  //   targetDateNum: null,
  //   status: null },
  // { product_line_id: 'breaker',
  //   seldate: '20210304',
  //   productName: '',
  //   productDesc: 'LR switch handle missing  (OTHER)',
  //   quantity: '1',
  //   issueRelated: null,
  //   supplierName: null,
  //   ncrCapturing: null,
  //   issueCapturing: 'ma assembly station',
  //   defectCategory: null,
  //   defectSubCategory1: null,
  //   defectSubCategory2: null,
  //   defectSubCategory3: null,
  //   rootCause: null,
  //   dispositionDecision: null,
  //   actionDecided: null,
  //   preventiveAction: null,
  //   respPrsn: null,
  //   targetDateNum: null,
  //   status: null }
  //  ];
  // let ws:XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  // let wb: XLSX.WorkBook = XLSX.utils.book_new();
  // XLSX.utils.book_append_sheet(wb, ws, 'test');
  // XLSX.writeFile(wb, 'inproc.xlsx');
  // console.log("are we really done?")
}

validateStartEndDate(_startDate:Date,_endDate:Date):boolean{
  if(_startDate > _endDate){
    this._notify.error('Failure','Invalid Date',this._dataService.failureOptions);
    return false;
  }

  return true;
}




  loadDateData():void{
    let _tmpIQIDayToken:IQIDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
    if(_tmpIQIDayToken == null){
      this.inProcessQualObj.addDateToken(this.currMonthDtObj);  
      _tmpIQIDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
    }
    // let _planQtyCounter:number = 0;
    // if(_tmpDPHDayToken.dateTokens){
    //   _tmpDPHDayToken.dateTokens.forEach((_dtToken:DPHToken) => {
    //     _planQtyCounter += _dtToken.quantity;
    //   })
    // }
    // this.planQty = _planQtyCounter + '';
    this.IQIDayTokenObj = _tmpIQIDayToken;
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }
  hasReadAccess(_pid: string) {
    return this._dataService.hasReadAccess(this.mId, _pid);
  }

}

